module.exports = "<h1 mat-dialog-title>\r\n    {{title}}\r\n</h1>\r\n<div mat-dialog-content>\r\n    <p>{{message}}</p>\r\n</div>\r\n\r\n<div mat-dialog-actions>\r\n    <button mat-button (click)=\"onDismiss()\">No</button>\r\n    <button mat-raised-button style =\"background: #4CAF50 ;color:white\" (click)=\"onConfirm()\">Yes</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/processor-closer-pipeline-reassignment/confirm-dialog/confirm-dialog.component.html
// module chunks = main